'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { RAW_ASSET_REVISION_FETCH, RAW_ASSET_REVISIONS_FETCH } from 'DesignData/actions/ActionTypes';
import RawAsset from 'DesignData/models/RawAsset';
const CURRENT_BUFFER_VERSION_ID = -1;

function revisions(state = SeamlessImmutable({
  revisions: {}
}), action) {
  switch (action.type) {
    case RAW_ASSET_REVISIONS_FETCH:
      {
        const {
          revisions: receivedRevisions
        } = action;

        if (!receivedRevisions) {
          return state;
        }

        const receivedRevisionsById = {};
        receivedRevisions.forEach(revision => {
          if (revision.id !== CURRENT_BUFFER_VERSION_ID && state.revisions[revision.id]) {
            //  This revision has already been downloaded
            return;
          }

          const revisionImmutable = new RawAsset(revision.object);
          receivedRevisionsById[revision.id] = revisionImmutable;
        });
        return SeamlessImmutable.set(state, 'revisions', Object.assign({}, state.revisions, {}, receivedRevisionsById));
      }

    case RAW_ASSET_REVISION_FETCH:
      {
        const {
          rawAsset,
          revisionId
        } = action;

        if (!rawAsset || !revisionId) {
          return state;
        }

        const revisionData = new RawAsset(rawAsset);
        return SeamlessImmutable.setIn(state, ['revisions', revisionId], revisionData);
      }

    default:
      {
        return state;
      }
  }
}

function byId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case RAW_ASSET_REVISION_FETCH:
    case RAW_ASSET_REVISIONS_FETCH:
      {
        const {
          resourceId
        } = action;

        if (!resourceId) {
          return state;
        }

        return SeamlessImmutable.set(state, resourceId, revisions(state[resourceId], action));
      }

    default:
      return state;
  }
}

export default combineReducers({
  byId
});